<template>
  <div class="privacy-hero card">
    <div class="privacy-pill pill">
      <span aria-hidden="true">🔒</span>
      <span>Política de privacidade</span>
    </div>

    <h1 class="privacy-title">Política de Privacidade do App Profissionais Android</h1>
    <p class="privacy-subtitle">
      Esta página explica como tratamos dados pessoais no App Profissionais Android e nos canais relacionados ao
      uso do EasySaúde.
    </p>

    <div class="privacy-meta-row">
      <div class="privacy-meta-chip">
        <strong>Controladora</strong>
        <span>PAULO HENRIQUE DOS SANTOS ANDRADE</span>
      </div>
      <div class="privacy-meta-chip">
        <strong>CNPJ</strong>
        <span>08.664.531/0001-90</span>
      </div>
      <div class="privacy-meta-chip">
        <strong>Contato LGPD</strong>
        <span>contato@sidsolucoes.com.br</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPageHero'
}
</script>

<style scoped>
.privacy-hero {
  padding: 28px;
  background: linear-gradient(180deg, rgba(77, 186, 135, 0.08), rgba(255, 255, 255, 1));
}

.privacy-title {
  margin: 16px 0 10px;
  font-size: 40px;
  line-height: 1.08;
  letter-spacing: -0.03em;
}

.privacy-subtitle {
  margin: 0;
  color: var(--easy-muted);
  font-size: 18px;
  line-height: 1.6;
  max-width: 68ch;
}

.privacy-meta-row {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.privacy-meta-chip {
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.privacy-meta-chip strong {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  color: var(--easy-dark);
}

.privacy-meta-chip span {
  color: var(--easy-muted);
  font-size: 14px;
  line-height: 1.4;
}

@media (max-width: 760px) {
  .privacy-hero {
    padding: 22px;
  }

  .privacy-title {
    font-size: 30px;
  }

  .privacy-meta-row {
    grid-template-columns: 1fr;
  }
}
</style>
